<template>
  <header id="topnav" class="defaultscroll sticky">
    <div class="container">
      <!-- Logo container-->
      <div>
        <b-link class="logo" :to="{ name: 'Home' }">
          <img src="@/assets/logo/logo.svg" height="50" alt="BrevisVelox.com" />
        </b-link>
      </div>

      <!--end login button-->
      <!-- End Logo container-->

      <div id="navigation">
        <!--end navigation menu-->

        <!--end login button-->
      </div>
      <!--end navigation-->
    </div>
    <!--end container-->
  </header>
</template>
<script>
import $ from "jquery";
export default {
  name: "Header",
  components: {},
  data() {
    return {
      navOpen: false,
      langs: [
        { locale: "en", lang: "ENG" },
        { locale: "sl", lang: "SLO" },
      ],
    };
  },
  mounted: function() {},
  methods: {
    toggleNav: function() {
      this.navOpen = !this.navOpen;
      $("#navigation").slideToggle(400);
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
    },
  },
};
/*
// Menu
$(".navbar-toggle").on("click", function(event) {
  $(this).toggleClass("open");
  $("#navigation").slideToggle(400);
});

$(".navigation-menu>li")
  .slice(-1)
  .addClass("last-elements");

$(".menu-arrow,.submenu-arrow").on("click", function(e) {
  if ($(window).width() < 992) {
    e.preventDefault();
    $(this)
      .parent("li")
      .toggleClass("open")
      .find(".submenu:first")
      .toggleClass("open");
  }
});

$(".navigation-menu a").each(function() {
  if (this.href == window.location.href) {
    $(this)
      .parent()
      .addClass("active");
    $(this)
      .parent()
      .parent()
      .parent()
      .addClass("active");
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .addClass("active");
  }
});

// Clickable Menu
$(".has-submenu a").click(function() {
  if (window.innerWidth < 992) {
    if (
      $(this)
        .parent()
        .hasClass("open")
    ) {
      $(this)
        .siblings(".submenu")
        .removeClass("open");
      $(this)
        .parent()
        .removeClass("open");
    } else {
      $(this)
        .siblings(".submenu")
        .addClass("open");
      $(this)
        .parent()
        .addClass("open");
    }
  }
});

$(".mouse-down").on("click", function(event) {
  var $anchor = $(this);
  $("html, body")
    .stop()
    .animate(
      {
        scrollTop: $($anchor.attr("href")).offset().top - 72,
      },
      1500,
      "easeInOutExpo"
    );
  event.preventDefault();
});
*/
</script>
